import Hero from "../components/Hero";
import PPDSection from "../components/PPDSection";
import Choice from "../components/Choice";
import RoadGames from "../components/RoadGames";
import Games from "../components/Games";
import PPD from "../components/PPD";
import PolarRPG from "../components/PolarRPG";
import Fortune from "../components/Fortune";
import RoadFinance from "../components/RoadFinance";
import Upcoming from "../components/Upcoming";
import Frost from "../components/Frost";
import Team from "../components/Team";
import Networks from "../components/Networks";
import Border from "../components/Border";

export default function Home() {
  return (
    <div>
      <Hero />
      <PPDSection />
      <Border />
      <Choice />
      <RoadGames />
      <Games />
      <Border />
      <PolarRPG />
      <Border />
      <PPD />
      <Border />
      <Fortune />
      <RoadFinance />
      <Upcoming />
      <Border />
      <Frost />
      <Border />
      <Team />
      <Networks />
    </div>
  );
}
